// components/Admin/AdminPanel.js
import React, { useRef, useState } from "react";
import axios from "axios";
import { url } from "../Api/config";
import { close_svg } from "../Svg/svgs";

const BACKEND_PDF_URL = `${url}/static/uploads/pdf/price.pdf`;

const AdminPanel = () => {
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState("");
    const [iframeSrc, setIframeSrc] = useState(`${url}/static/uploads/pdf/price.pdf`);
    const inputRef = useRef(null);

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!file) return;

        const formData = new FormData();
        formData.append("pdf", file);

        try {
            await axios.post(`${url}/api/upload/pdf`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setStatus("Файл успешно загружен");
            setFile(null); 

            if (inputRef.current) inputRef.current.value = null;

            // Обновляем iframe, добавив временную метку
            setIframeSrc(`${url}/static/uploads/pdf/price.pdf?t=${Date.now()}`);

        } catch (err) {
            setStatus("Ошибка при загрузке");
        }
    };

    // const handleRemove = () => {
    //     setFile(null);
    //     setStatus("");
    // };
    const handleRemove = () => {
        setFile(null);
        setStatus("");
        if (inputRef.current) {
            inputRef.current.value = null; // Сброс input вручную
        }
    };

    return (
        <div style={{ padding: "10px 70px", textAlign: "center" }}>
            <label>Загрузка нового price.pdf</label>

            <iframe
                // src={BACKEND_PDF_URL + "#toolbar=0&navpanes=0&scrollbar=0"}
                src={iframeSrc + "#toolbar=0&navpanes=0&scrollbar=0"}
                title="Прайс"
                width="100%"
                height="600px"
                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            ></iframe>

            <form onSubmit={handleUpload} style={{ marginTop: "20px", display: 'flex' }}>
                <input
                    ref={inputRef}
                    type="file"
                    accept="application/pdf"
                    onChange={(e) => setFile(e.target.files[0])}
                />

                {file && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "15px",
                        }}
                    >
                        {/* <span>{file.name}</span> */}
                        <div onClick={handleRemove} size={24} >
                            {close_svg}
                        </div>
                        <button
                            type="submit"
                            style={{
                                padding: "10px 20px",
                                fontSize: "16px",
                                cursor: "pointer",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                            }}
                        >
                            Загрузить
                        </button>
                    </div>
                )}
            </form>

            {status && <p style={{ marginTop: "20px" }}>{status}</p>}
        </div>
    );
};

export default AdminPanel;
